export default {
    supplierId: {
        presence: true,
        type: "string",
    },
};
